<template>
  <div class="row-fill container-row">
    <vue-headful :title="'مُرَيجَع | نتائج البجث عن' + query"/>
    <div class="col-fill container-col">
      <h1 class="row-fit">
        نتائج البحث عن:
        {{ query }}
      </h1>
      <div class="row-fill container-col-wrapped">
        <template v-if="results.colls.length > 0">
          <template v-for="patternGroup of filteredPatternGroups">
            <div
              v-for="c of patternGroup.colls"
              :key="c.lempos + c.pattern"
              class="wrappable-row-fit candidate"
              :class="getClass(c)"
            >
              <h1>
                <router-link :to="{ name: 'collocation', params: { lempos: getCore(c), collLempos: c.lempos.join(' '), collPattern: c.pattern, } }">
                  {{ c.citation_form.join(" ") }}
                </router-link>
              </h1>
              <div class="meta">
                <b> {{c.pattern}} </b>
                ترددها في المتونة
                <b> {{ arabizeNumerals(c.freq) }} </b>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <template v-for="lemmaGroup of results.lemmas">
            <!-- Hacky, filtering preps out here -->
            <div v-for="l of lemmaGroup" :key="l.lempos" class="wrappable-row-fit candidate" :class="getClass(l)" v-if="getClass(l)!='adp'">
              <h1>
                <router-link :to="{ name: 'lemma', params: { lempos: l.lempos } }">
                  {{ lemposToLemma(l.lempos) }}
                </router-link>
              </h1>
              <div class="meta">
                <b> {{ arabicPos(lemposToPos(l.lempos)) }} </b>
                تردده في المتونة
                <b> {{ arabizeNumerals(l.freq) }} </b>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../mixins/api.js'
import { PATTERN_CLASSES } from '../lib/patters'

import vueHeadful from 'vue-headful'

export default {
  name: 'Search',
  mixins: [api],
  props: {
    query: String
  },
  components: {
    vueHeadful
  },
  data: function () { return { results: { lemmas: [], colls: [] } } },
  created: function () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    lemmaCandidates: function () {
      return [].concat(...this.results.lemmas).map(l => l.lempos).filter(lp => this.lemposToPos(lp) === 'NOUN')
    },
    filteredPatternGroups: function () {
      return this.results.colls.filter(patternGroup => patternGroup.pattern in PATTERN_CLASSES)
    }
  },
  methods: {
    fetchData: function () {
      var t = this
      this.search({query: this.query, user: this.$store.state.user})
        .then(function (response) {
          t.results = response.data
        })
    },
    selectCollocation: function (c) {
      this.$store.dispatch('loadCollocation', { lempos: c.lempos.join(' '), pattern: c.pattern })
      this.$store.commit('selectCollocation', { lempos_string: c.lempos.join(' '), pattern: c.pattern })
    },
    getClass: function (c) {
      if ('pattern' in c) {
        return PATTERN_CLASSES[c.pattern]
      }
      return this.lemposToPos(c.lempos).toLowerCase()
    },
    getCore: function (c) {
      // Return the first noun of the collocation that is also part of the query
      // Fall back to first noun of the collocation or the first word if theres no noun
      const isNoun = lp => this.lemposToPos(lp) === 'NOUN'
      const nounsInColl = c.lempos.filter(isNoun)
      const nounsInQuery = [].concat(...this.results.lemmas).map(l => l.lempos).filter(isNoun)
      for (var n of nounsInColl) {
        if (n in nounsInQuery) { return n }
      }
      if (nounsInColl.length > 0) {
        return nounsInColl[0]
      }
      return c.lempos[0]
    }
  }
}
</script>

<style scoped>
  .candidate {
    border-right: 2px solid var(--fg-color);
    background-color: var(--bg-color);
    /* background-color: #F5F5F5; */
    margin: 20px;
  }
  .meta {
    padding: 0px 20px 20px 0
  }
</style>
